import { copyLink } from '../utils/copyLink';
import { observer } from 'mobx-react';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import { ControlIcons } from 'owa-control-icons';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import {
    ContextualMenu,
    IContextualMenuItem,
    DirectionalHint,
} from 'office-ui-fabric-react/lib/ContextualMenu';

let styles = require('./CalendarsPublishedComponent.scss');

export interface CalendarPublishedICSContextMenuProps {
    anchorPoint: string | Element | MouseEvent | IPoint;
    link: string;
    onDismiss: () => void;
}

@observer
export default class CalendarPublishedICSContextMenu extends React.Component<
    CalendarPublishedICSContextMenuProps,
    {}
> {
    render() {
        let { anchorPoint, onDismiss } = this.props;

        return (
            <div className={styles.contextMenu}>
                {anchorPoint && (
                    <ContextualMenu
                        items={this.populateMenuItems()}
                        target={anchorPoint}
                        onDismiss={onDismiss}
                        directionalHint={DirectionalHint.bottomLeftEdge}
                    />
                )}
            </div>
        );
    }

    private populateMenuItems = (): IContextualMenuItem[] => {
        let menuItems: IContextualMenuItem[] = [];
        menuItems.push({
            key: 'copyLink',
            name: strings.options_publishedCalendars_ContextMenu_CopyLink,
            onClick: () => {
                this.onCopyLink();
            },
            iconProps: {
                iconName: ControlIcons.Link,
            },
        });

        menuItems.push({
            key: 'download',
            name: strings.options_publishedCalendars_ContextMenu_Download,
            onClick: () => {
                window.open(this.props.link);
            },
            iconProps: {
                iconName: ControlIcons.Download,
            },
        });

        return menuItems;
    };

    private onCopyLink = () => {
        copyLink(this.props.link);
        this.props.onDismiss();
    };
}
